export class Contract {
    Id: number;
    Number: number;
    ProductId: number;
    Description: string;
    DocumentStatusId: number;
    Name: string;
    PersonId: number;
    StartDate: Date;
    EndDate: Date;
    PolicyHolder: string;
    PolicyHolderPhone: string;
    AgentId: number;
    ContractsAgents: object;
}